import { AbstractEnum } from "./abstract-enum";

export class TaskPriorityEnum extends AbstractEnum {
  public static LOW = 1 as const;
  public static MED = 5 as const;
  public static HIGH = 10 as const;

  public static choices = {
    [TaskPriorityEnum.LOW]: "Low",
    [TaskPriorityEnum.MED]: "Medium",
    [TaskPriorityEnum.HIGH]: "High",
  };
}

export type TaskPriorityEnumType = keyof typeof TaskPriorityEnum.choices;
